<div class="dialog-backdrop" *ngIf="isVisible" (click)="onBackdropClick($event)" (keydown.escape)="close()">
  <div class="webhook-dialog" (click)="$event.stopPropagation()" (keydown)="onKeyDown($event)" role="dialog"
    aria-modal="true">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ dialogTitle }}</h2>
    </div>

    <div class="dialog-body">
      <form class="form-groups" (ngSubmit)="handleSubmit()">
        <!-- Merchant info (admin edit mode — read-only) -->
        <div class="form-group" *ngIf="mode === 'edit' && showMerchantInfo">
          <label for="merchantDisplay" class="form-label">Merchant Name</label>
          <input id="merchantDisplay" type="text" class="form-input"
                 [value]="merchantDisplay" disabled />
        </div>
        <!-- Merchant lookup (create mode) -->
        <div class="form-group" *ngIf="mode === 'create'">
          <label for="merchantQuery" class="form-label">
            Merchant Name or Merchant ID
          </label>
          <div class="merchant-search-field" [ngClass]="{ 'invalid': merchantError }">
            <input id="merchantQuery" type="text" class="merchant-search-input" name="merchantQuery"
                  [(ngModel)]="merchantQuery"
                  (ngModelChange)="onMerchantQueryChange()"
                  (keyup.enter)="searchMerchant()"
                  [disabled]="isValidatingMerchant"
                  [attr.aria-invalid]="merchantError"
                  placeholder="Enter merchant name or ID" />
            <button type="button" class="merchant-search-icon-btn"
                    [disabled]="!merchantQuery.trim() || isValidatingMerchant"
                    (click)="searchMerchant()"
                    aria-label="Search merchant">
              <i class="pe-7s-search"></i>
            </button>
          </div>
          <div class="field-error" *ngIf="merchantError">
            <span class="error-icon">!</span>
            <span>{{ merchantError }}</span>
          </div>
          <div class="merchant-confirm" *ngIf="merchantValidated && validatedMerchant">
            ✓ {{ validatedMerchant.merchantName }} ({{ validatedMerchant.merchantId }})
          </div>
        </div>

        <!-- Same URL toggle -->
        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input type="checkbox" [checked]="sameUrl" (change)="onToggleSameUrl()" />
            <span>Use same URL for Sale & Refund</span>
          </label>
        </div>

        <!-- Sale URL -->
        <div class="form-group">
          <label for="saleUrl" class="form-label">
            Sale URL
            <span class="inline-error" *ngIf="saleUrlError">{{ saleUrlError }}</span>
          </label>
          <input id="saleUrl" type="text" class="form-input" name="saleUrl" [(ngModel)]="formSaleUrl"
            (ngModelChange)="onSaleUrlChange()" [ngClass]="{ 'invalid': saleUrlError }"
            [attr.aria-invalid]="saleUrlError" />
        </div>

        <!-- Refund URL -->
        <div class="form-group">
          <label for="refundUrl" class="form-label">
            Refund URL
            <span class="inline-error" *ngIf="!sameUrl && refundUrlError">{{ refundUrlError }}</span>
          </label>
          <input id="refundUrl" type="text" class="form-input" name="refundUrl" [(ngModel)]="formRefundUrl"
            [disabled]="sameUrl" (ngModelChange)="onRefundUrlChange()"
            [ngClass]="{ 'invalid': !sameUrl && refundUrlError }" [attr.aria-invalid]="!sameUrl && refundUrlError" />
        </div>
      </form>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn-primary" [disabled]="!isFormValid() || isSubmitting" (click)="handleSubmit()">{{
        submitButtonText }}</button>
      <button type="button" class="btn-secondary" (click)="close()">Close</button>
    </div>
  </div>
</div>